import {css} from '@emotion/css';

import {colours, spacing} from '../../styles/js/variables';

const styles = {
  container: css`
    label: languageBanner;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-end;
    width: 100%;
    padding: ${spacing.XXS} ${spacing.XS};
    background-color: ${colours.general.WHITE};
  `,
  label: css`
    label: languageBanner__label;
    padding-right: ${spacing.XS};
  `,
}

export default styles
